// removed by extract-text-webpack-plugin
module.exports = {"select":"Select-honda__select___1L_vb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Select/Select.honda.css
 ** module id = 87
 ** module chunks = 0 1
 **/